import type { ReactNode } from "react";
import { Lock } from "lucide-react";

export function SectionHeader({
  title,
  lead,
  meta,
  actions,
  titleId,
}: {
  title: string;
  lead: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  titleId?: string;
}) {
  return (
    <div className="flex flex-wrap items-start gap-4 px-4 pt-3.5 pb-2.5 max-compact:px-2">
      <div className="min-w-0 flex-[1_1_360px]">
        <h1 id={titleId} tabIndex={-1} className="m-0 text-2xl font-semibold">
          {title}
        </h1>
        <p className="m-0 mt-[3px] max-w-[780px] text-ui text-muted">{lead}</p>
        {meta ? (
          <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-md text-muted [&_b]:font-strong [&_b]:text-fg">
            {meta}
          </div>
        ) : null}
      </div>
      {actions ? <div className="relative flex flex-wrap items-center gap-1.5">{actions}</div> : null}
    </div>
  );
}

export function ReadOnlyNote({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-divider bg-surface-2 py-px pr-[9px] pl-[7px] text-md text-muted">
      <Lock size={12} strokeWidth={1.8} aria-hidden="true" />
      {children}
    </span>
  );
}

export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="flex min-h-10 flex-wrap items-center gap-2 px-4 pb-2 max-compact:px-2">{children}</div>;
}

export function ToolbarSpacer() {
  return <span className="flex-1" />;
}

export function DrawerSection({ title, note, children }: { title: string; note?: string; children: ReactNode }) {
  return (
    <section>
      <h3 className="m-0 mb-1.5 text-xs font-semibold tracking-[0.06em] text-muted uppercase">
        {title}
        {note ? <span className="ml-2 font-normal tracking-normal normal-case">{note}</span> : null}
      </h3>
      {children}
    </section>
  );
}
